import ThSarabun from "../fonts/THSarabunNew.ttf";
import ThSarabunBold from "../fonts/THSarabunNew-Bold.ttf";
import ThSarabunItalic from "../fonts/THSarabunNew-Italic.ttf";
import ThSarabunBoldItalic from "../fonts/THSarabunNew-BoldItalic.ttf";
import { Font } from "@react-pdf/renderer";

export const registerFont = () => {
  Font.register({ family: "ThSarabun", src: ThSarabun });
  Font.register({ family: "ThSarabunBold", src: ThSarabunBold });
  Font.register({ family: "ThSarabunItalic", src: ThSarabunItalic });
  Font.register({ family: "ThSarabunBoldItalic", src: ThSarabunBoldItalic });
  Font.registerHyphenationCallback((word) => {
    let n = [];
    for (let i = 0; i < word.length; i++) {
      if (word.charAt(i) == 9) {
        console.log(word.charCodeAt(i) + "," + word.charAt(i) + ">>");
        n = [...n, String.fromCharCode([32, 32, 32])];
      } else {
        n = [...n, word.charAt(i)];
      }
    }
    //return [word + " "];
    return n;
  });
};
